module.exports = __webpack_public_path__ + "img/success.28db47f4.svg";